import React from 'react';

export const ValidationMessage = ({ message }) => {
	return <small className="form-text alert-danger pl-5">{message}</small>;
};
